export default {
  slug: "vulnerable-customers",
  title: "Vulnerable customers",
  tier: "UK lending",
  group: "uk",
  appliesTo: "Daksfirst Limited; borrowers, guarantors and applicants in the United Kingdom",
  lead: "Anyone can find themselves in circumstances that make it harder to deal with a lender. We think of that as a reason to slow down, listen, and adjust.",
  sections: [
    { id: "about", h: "What we mean", body: [
      "Illness, bereavement, caring responsibilities, a relationship breakdown, a loss of income, a disability, or simply the stress of a transaction that has not gone to plan: any of these can make it harder to deal with a lender. The Financial Conduct Authority calls this vulnerability. We think of it as a reason to slow down, listen, and adjust."
    ]},
    { id: "what", h: "What we will do", body: [
      { ul: [
        "If you tell us about a circumstance that affects you, we will record it once, with your consent, so you do not have to explain it again each time you contact us.",
        "We will adjust how we communicate: by telephone rather than email, in larger print, through a nominated third party, or at a pace that suits you.",
        "We will give you more time to make decisions where the timetable allows, and we will tell you plainly where it does not and why.",
        "We will never use your circumstances as a reason to decline to help, and we will not treat a disclosure as a credit event.",
        "Our people are trained to recognise signs of vulnerability, including where you have not told us, and to respond appropriately.",
        "Where your circumstances mean you should take independent advice before proceeding, we will say so and will not pressure you to complete."
      ]}
    ]},
    { id: "acting", h: "Acting for someone else", body: [
      "If you hold a power of attorney or a deputyship order for a borrower, or are dealing with a borrower's estate, contact us with evidence of your authority and we will deal with you directly. We will not discuss an account with a third party without that evidence, for the borrower's protection."
    ]},
    { id: "tell", h: "Tell us", body: [
      "Contact your relationship manager, email info@daksfirst.com, or telephone +44 (0)20 7698 2709. If you would prefer to write, our address is 8 Hill Street, London W1J 5NG. If your circumstances mean you are finding it hard to keep up payments, our Financial difficulty page explains what we can do."
    ]}
  ],
  version: "1.0",
  status: "Effective 22 September 2026",
  owner: "Director"
};
